import { ExamEventHeader } from '@exam-center/exam-event-schedule';
import { Outlet } from 'react-router-dom';

export default function ExamEventLayout() {
  return (
    <>
      <ExamEventHeader />
      <Outlet />
    </>
  );
}
